import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ContentSection from "./components/ContentSection";
import ArticleCards from "./components/ArticleCards";
import TrustSection from "./components/TrustSection";
import CTASection from "./components/CTASection";
import { useSEO, buildWebSiteSchema, buildOrganizationSchema } from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "CSSBuy Spreadsheet Guia Completo 2026 — Aprenda a Usar, Comparar e Economizar",
    description: "Guia completo do CSSBuy Spreadsheet 2026. Aprenda como usar CSSBuy spreadsheet passo a passo, compare agentes de compras da China, economize dinheiro e organize seus pedidos com eficiência. Ferramentas, dicas e comparações para iniciantes.",
    keywords: "cssbuy spreadsheet, cssbuy guia, como usar cssbuy, agente cssbuy, spreadsheet china shopping, cssbuy 2026",
    canonicalPath: "/",
    ogType: "website",
    jsonLd: [buildWebSiteSchema(), buildOrganizationSchema()],
  });

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ContentSection />
      <ArticleCards />
      <TrustSection />
      <CTASection />
      <Footer />
    </main>
  );
}